module.exports = require("@jswork/react-upload");